module.exports = __webpack_public_path__ + "static/media/lock.517348eb.svg";